export const parseAspectRatioToNumber = (
    aspectRatio: string,
    defaultAspectRatio = 2 / 3
) => {
    const parts = aspectRatio.split(':')
    const width = parseInt(parts[0])
    const height = parseInt(parts[1])
    if (width && height) {
        const numberRatio = width / height
        if (numberRatio) return numberRatio
    }

    return defaultAspectRatio
}
